import { Pipe, PipeTransform } from "@angular/core";

@Pipe({
  name: "translateProjectImageTag",
  standalone: true,
})
export class TranslateProjectImageTagPipe implements PipeTransform {
  transform(tag: string): string {
    const tags: Record<string, string> = {
      TAG_1: $localize`:@@monitoring.projectImageTags.tag1:Tag 1`,
      TAG_2: $localize`:@@monitoring.projectImageTags.tag2:Tag 2`,
      TAG_3: $localize`:@@monitoring.projectImageTags.tag3:Tag 3`,
    };

    return tags[tag] ?? $localize`:@@monitoring.projectImageTags.unknown:Unknown tag`;
  }
}
